/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Corporate_Finance_Validation_TestsInputs */

const en_corporate_finance_validation_tests = /** @type {(inputs: Corporate_Finance_Validation_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Validation Tests`)
};

const nl_corporate_finance_validation_tests = /** @type {(inputs: Corporate_Finance_Validation_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Validatietests`)
};

/**
* | output |
* | --- |
* | "Validation Tests" |
*
* @param {Corporate_Finance_Validation_TestsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const corporate_finance_validation_tests = /** @type {((inputs?: Corporate_Finance_Validation_TestsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Corporate_Finance_Validation_TestsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_corporate_finance_validation_tests(inputs)
	return en_corporate_finance_validation_tests(inputs)
});